/**
 * Компонент защищённого маршрута.
 * Проверяет авторизацию и роль пользователя перед отображением страницы.
 * Неавторизованных перенаправляет на страницу входа.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserRole } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;  // Если указана, проверяется соответствие роли
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  // Пока идёт проверка токена — показываем индикатор загрузки
  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>Загрузка...</div>;
  }

  // Если пользователь не авторизован — на страницу входа
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Если требуется определённая роль, но она не совпадает — на главную
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
